import { useEffect, PropsWithChildren, CSSProperties } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.scss';
import CloseIcon from '@mui/icons-material/Close';

type ModalProps = {
	open: boolean;
	toggleOpen: (b:boolean) => void;
	showCloseButton?: boolean;
	closeOnEscape?: boolean;
	closeOnClickOutside?: boolean;
	padding?: number;
	blurBackdrop?: boolean;
	glow?: boolean;
}

export const Modal = (props:PropsWithChildren<ModalProps>) => {
	const {
		open,
		toggleOpen,
		showCloseButton = true,
		closeOnEscape,
		closeOnClickOutside,
		padding = 32,
		blurBackdrop = false,
		glow = false,
		children
	} = props;
	const setPosition = () => {
		const styles: CSSProperties = {};
		const indent = 12;
		styles.marginTop = `${0 - padding + indent}px`;
		styles.marginRight = `${0 - padding + indent}px`;
		return styles;
	}
	useEffect(() => {
		if (!closeOnEscape) return;
		if (!open) return;
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Escape') {
				toggleOpen(false);
			}
		};
		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [open, closeOnEscape]);
	return (
		<>
			{open && createPortal(<div data-testid={'@Ofload-Modal'} className={`${styles.container} ${blurBackdrop ? styles.blur : ''}`} onClick={() => { closeOnClickOutside && toggleOpen(false) }}>
				<div className={`${styles.modal} ${glow ? styles.glow : ''}`} style={{ padding: `${padding}px` }} onClick={(e) => { e.stopPropagation() }}>
					{showCloseButton && <button onClick={() => { toggleOpen(false) }} className={styles.closeButton} style={setPosition()} aria-label={'Toggle Modal Button'}><CloseIcon /></button>}
					{children}
				</div>
			</div>, document.body)}
		</>
	);
}
